import AnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";

export function setContinuousAnimate(symbols: SymbolComponent[], value: boolean) {
    symbols.forEach((symbol) => {
        const behaviour = symbol.getBehaviourByName<AnimateSymbolBehaviour>("Animate");
        if (behaviour) {
            behaviour.continuous = value;
        }
    });
}
